// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';

import App from './App';//引入了一个组件
import router from './router';
import ElementUI from 'element-ui';
import {Message,Pagination,DatePicker,Rate, Upload, Dialog, Input, Popover,Button,MessageBox,Progress} from 'element-ui'
import  Vuelazyload from 'vue-lazyload';
import TIM from 'tim-js-sdk';
import COS from 'tim-upload-plugin'
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Rate);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Popover);
Vue.use(Button);
// Vue.use(MessageBox);
Vue.use(Progress);
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message=Message;
Vue.use(Vuelazyload);

import 'element-ui/lib/theme-chalk/index.css'

let options ={
  SDKAppID:1400399266
}
let tim = TIM.create(options);
tim.setLogLevel(0);
tim.registerPlugin({'tim-upload-plugin': COS});
window.tim = tim
window.TIM = TIM
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
// import '@/style/style.css'
//配置导航守卫
router.beforeEach((to, from, next) => {
  // ...

  next(true);
});
router.afterEach((to, from) => {
  // ...
  if(from.fullPath == '/loginRegister'){
    //alert('页面信息保存成功！');
  }
});
import store from './store/index';
// var touserid = '';
// var length = '';
Vue.prototype.$touserid = '';
Vue.prototype.$length = '';

tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function(event) {
  // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
  // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
  // event.data - 存储 Conversation 对象的数组 - [Conversation]
  var conversationList = event.data;
  console.log(conversationList,'未读计数1');

  var touserid = conversationList[0].userProfile.userID;
  // console.log(touserid);

  var number = 0
  conversationList.forEach(e => {
    number = number + e.unreadCount
  })
  console.log(number,'未读计数2')
  if(number>0) {
    var length = number;
    // console.log(length,'未读计数3')
  }
  Vue.prototype.$touserid = touserid;
  Vue.prototype.$length = length;
});


Vue.config.productionTip = false;

Vue.use(Vuelazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data:()=>{
    return{
      chezhong:'',
      userNum:'',
      userComponey:0,
      userId:'',
      fabuNum:0,
      juzhan:{},
      componeyId:'',
      touserid:touserid,
      length:length
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js